import { __awaiter } from "tslib";
import React, { useRef } from "react";
import connect from "Shared/connect";
import DropDown from "Shared/DropDown";
import { translate } from "Shared/translate";
import * as styles from "./base.scss";
import { ENTER } from "Shared/keyboard";
import { setDiscountType, setDiscountValue, } from "../../Checkout/action-creators";
import classnames from "classnames";
import { Input } from "Shared/Fields";
const DISCOUNT_PERCENT_LIMIT = 90;
const PriceSupplier = (props) => {
    const discountTypeIsValid = (props.validDiscounts || []).some((x) => !x.disabled && x.value === props.discountType);
    const discountType = discountTypeIsValid ? props.discountType : "percent";
    const discountInput = useRef(null);
    const sendCurrentValue = useRef();
    const changeDiscountType = (value) => {
        props.setDiscountType(props.code, value);
    };
    const onInputChange = (value) => {
        if (props.discountValue !== Number(value))
            sendCurrentValue.current = props.setDiscountValue(props.code, Number(value));
    };
    const onDiscountBlur = () => __awaiter(void 0, void 0, void 0, function* () {
        if (props.discountType === "percent" &&
            props.discountValue > DISCOUNT_PERCENT_LIMIT) {
            props.toggleProductSample(props.code);
        }
        sendCurrentValue.current && (yield sendCurrentValue.current());
        discountInput.current.element.value = parseFloat(discountInput.current.element.value).toString();
    });
    const keyPressHandler = (e) => {
        if (e.keyCode === ENTER) {
            discountInput.current.blur();
        }
    };
    if (!props.isSupplierSalesman || props.validDiscounts == null) {
        return null;
    }
    const options = props.validDiscounts.map((option) => {
        return {
            text: option.displayName,
            value: option.value,
            disabled: option.disabled,
            tooltip: option.tooltip,
            subText: null,
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames({ [styles.useNewDesign]: props.useNewDesign }) },
            React.createElement(DropDown, { options: [
                    {
                        text: translate("/shared/selectoption"),
                        value: null,
                        disabled: false,
                        subText: null,
                    },
                    ...options,
                ], value: !props.isProductSample ? null : discountType, onChange: changeDiscountType, disabled: !props.isProductSample, appearance: "small" }),
            !props.useNewDesign && (React.createElement("div", { className: styles.inputWrapper },
                React.createElement(Input, { type: "number", ref: discountInput, onChange: (e) => onInputChange(e.target.value), value: props.discountValue, onBlur: () => onDiscountBlur(), onKeyDown: (e) => keyPressHandler(e), disabled: !props.isProductSample }),
                React.createElement("span", { className: styles.selectedValue },
                    options.find((x) => x.value === discountType).text,
                    discountType !== "percent" &&
                        ` (${translate("/SupplierSalesman/Discount/Per")} ${!!props.unitShortName &&
                            props.unitShortName.toLocaleLowerCase()})`))),
            props.useNewDesign && (React.createElement("div", { className: styles.inputWrapper },
                React.createElement(Input, { type: "number", ref: discountInput, onChange: (e) => onInputChange(e.target.value), min: 1, value: props.discountValue > 0 ? props.discountValue : null, onBlur: () => onDiscountBlur(), onKeyDown: (e) => keyPressHandler(e), disabled: !props.isProductSample, placeholderText: props.discountValue +
                        " " +
                        (discountType !== "percent"
                            ? ` ${translate("/SupplierSalesman/Discount/PerShort")}${!!props.unitShortName &&
                                props.unitShortName.toLocaleLowerCase()}`
                            : "%") }))))));
};
export default connect((state) => ({
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
}), (dispatch) => ({
    setDiscountType: (code, type) => dispatch(setDiscountType(code, type)),
    setDiscountValue: (code, value) => dispatch(setDiscountValue(code, value)),
}))(PriceSupplier);
